import React, { useState, useEffect } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { getDayOfYear, getDateFromDayOfYear } from '../utils/planUtils';

interface DateNavigationProps {
  currentDayOfYear: number;
  onDayOfYearChange: (dayOfYear: number) => void;
}

const DateNavigation: React.FC<DateNavigationProps> = ({
  currentDayOfYear,
  onDayOfYearChange,
}) => {
  // Convert currentDayOfYear to dayjs object for the date picker
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(
    dayjs(getDateFromDayOfYear(currentDayOfYear))
  );

  // Update selected date when currentDayOfYear prop changes
  useEffect(() => {
    setSelectedDate(dayjs(getDateFromDayOfYear(currentDayOfYear)));
  }, [currentDayOfYear]);

  // Handle date selection from date picker
  const handleDateChange = (newDate: Dayjs | null) => {
    if (newDate) {
      setSelectedDate(newDate);
      const dayOfYear = getDayOfYear(newDate.toDate());
      onDayOfYearChange(dayOfYear);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className='flex items-center gap-2 w-80'>
        <DatePicker
          label='Select Date'
          value={selectedDate}
          onChange={handleDateChange}
          slotProps={{
            textField: {
              size: 'small',
              sx: { width: '180px' },
            },
          }}
        />
      </div>
    </LocalizationProvider>
  );
};

export default DateNavigation;
